export function appendPdfBlobToFormData(formData, pdfBlob, filename = 'finder-result.pdf') {
  if (!pdfBlob) {
    return;
  }

  const pdfFile = new File([pdfBlob], filename, {
    type: pdfBlob.type || 'application/pdf',
  });

  formData.append('pdfBlob', pdfFile);
}

export function getFormDataRequestConfig() {
  return {
    transformRequest: [
      (data, headers) => {
        if (headers?.delete) {
          headers.delete('Content-Type');
          headers.delete('content-type');
        } else {
          // eslint-disable-next-line no-param-reassign
          delete headers?.['Content-Type'];
          // eslint-disable-next-line no-param-reassign
          delete headers?.['content-type'];
        }

        return data;
      },
    ],
  };
}
